import ABusinessHourInputField from './index.vue';

ABusinessHourInputField.install = app => {
  app.component(ABusinessHourInputField.name, ABusinessHourInputField);
};

export default ABusinessHourInputField;
